import { inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export function appIconsInitializer() {
  return (): void => _registerIconSet('syn', 'syn-icons.svg');
}

const _registerIconSet = (namespace: string, fileName: string): void => {
  const _iconRegistry = inject(MatIconRegistry);
  const _sanitizer = inject(DomSanitizer);

  _iconRegistry.addSvgIconSetInNamespace(
    namespace,
    _sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${fileName}`)
  );

  // Pre-warm the SVG set cache so icons are available synchronously when first shown.
  // Without this, the HTTP fetch fires on first use, which on isPrimaryScreen=true
  // (no footer controls to trigger the fetch early) or slow networks causes icons
  // to be missing during auto-rotation or in the control bar.
  const iconsToWarm = [
    'thumbs_up_v3',
    'topic',
    'thumbs_up_outlined',
    'star_new',
    'comment_new',
    'share',
    'transcript',
    'replay',
    'summarize_outline',
    'home',
    'trending_up_v3',
  ];
  for (const icon of iconsToWarm) {
    _iconRegistry.getNamedSvgIcon(icon, namespace).subscribe({
      error: (error: unknown) =>
        console.warn(
          `[appIconsInitializer] warm error for icon "${icon}" in namespace "${namespace}" from "${fileName}"`,
          error
        ),
    });
  }
};
